import { Metamodel } from 'app/model/base/model';
import { Named, Owned } from '../base/named';
import { DataFlowExpression } from './dataflowexpression';

@Metamodel.model({
    name: 'dataflowfunction',
    display: ['dataflowfunction', 'dataflowfunctions']
})
export class DataFlowFunction extends Named {
    public className: string;
    public funcExpression: DataFlowExpression = Owned.create<DataFlowExpression>(DataFlowExpression.MODEL, this);
    public paramTypes: string[];

    constructor(name?: string, description?: string, id?: number, public returnType?: string) {
        super(name, description, id);
    }
}
